import { useOptroImportIfAvailable } from "../../contexts/optroImportContext";
import { useWorkStepOptroImportIfAvailable } from "../../contexts/workStepOptroImportContext";
import { useOptroImportInterest } from "../../hooks/useOptroImportInterest";
import { ImportTaskCard } from "./ImportTaskCard";

interface ImportTasksSectionProps {
  // Called after an import is opened, so the popover can close.
  onOpenImport: () => void;
}

// Background Tasks' "Imports" section: the user's Optro imports (controls
// and work steps) from the last 24h, newest first, read from the import
// trackers. It is mounted only while Background Tasks is open, and keeps both
// trackers polling for as long as it is.
export const ImportTasksSection = ({
  onOpenImport,
}: ImportTasksSectionProps) => {
  const controls = useOptroImportIfAvailable();
  const workSteps = useWorkStepOptroImportIfAvailable();
  useOptroImportInterest(controls?.registerInterest);
  useOptroImportInterest(workSteps?.registerInterest);
  const entries = [
    ...(controls
      ? controls.jobs.map((tracked) => ({
          tracked,
          kindLabel: "Control import",
          open: () => controls.openImport(tracked.id),
        }))
      : []),
    ...(workSteps
      ? workSteps.jobs.map((tracked) => ({
          tracked,
          kindLabel: "Work step import",
          open: () => workSteps.openImport(tracked.id),
        }))
      : []),
  ].sort(
    (a, b) => Date.parse(b.tracked.createdAt) - Date.parse(a.tracked.createdAt),
  );

  if (entries.length === 0) return null;

  return (
    <div className="space-y-2">
      <h5 className="text-xs font-medium uppercase tracking-wide text-gray-500">
        Imports
      </h5>
      {entries.map(({ tracked, kindLabel, open }) => (
        <ImportTaskCard
          key={`${kindLabel}:${tracked.id}`}
          kindLabel={kindLabel}
          tracked={tracked}
          onOpen={() => {
            open();
            onOpenImport();
          }}
        />
      ))}
    </div>
  );
};
